import BackgroundMedia from '../components/backgroundMedia'

class BackgroundMedias {
	components: BackgroundMedia[] = []

    init(container: HTMLElement = document.body) {
		container.querySelectorAll<HTMLElement>('.hg-background-media-wrapper').forEach(wrapper => {
			const el = wrapper.querySelector<HTMLElement>('.hg-background-media')
			if (!el) return
			else this.components.push(new BackgroundMedia(wrapper, el))
		})
		this.components.forEach(component => component.init())
    }

	update(newContent: Element) {
		this.cleanup()
		this.init(newContent as HTMLElement)
	}

	refresh() {
		this.components.forEach(component => component.refresh())
	}

	cleanup() {
		this.components.forEach(component => component.cleanup())
		this.components = []
	}
}

export default new BackgroundMedias()